import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Streamingapp = () => {
  return (
    <div className="streaming_app p-100" style={{ backgroundColor: "#F6F6F6" }}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h2>Developing The Best Streaming Apps Out There</h2>
              <p>
                Best music apps like Spotify and Apple Music have allowed users
                to access any type of music in any genre, by any singer, in any
                country through the internet with incredible ease.
              </p>
              <p>
                This has all been made possible with the rise of streaming
                capabilities within these apps. Now users don’t need to download
                songs onto their devices, which was a long, drawn-out process.
                They can now just easily stream their favorite songs, TV shows,
                and movies on their favorite streaming apps.
              </p>
              <p>
                These top streaming apps are incredibly fast, they do not take
                up a lot of your mobile’s storage or computing power and can
                help you locate any track and play it within a matter of seconds
                with just a few taps.
              </p>
              <p>
                The app stores now have a lot of different types of streaming
                apps. From Netflix to Spotify, streaming apps have become all
                the rage these days. Our music app developers can help you build
                a perfect streaming app that can easily play VOD or Music with
                incredible ease.
              </p>
              <p>
                Moreover, we also understand Digital Rights Management and can
                ensure that your products or media files within the app remain
                in protected use for the benefit of the user.
              </p>
              <p>
                We understand the expectations of the market perfectly and if
                you want to make a streaming app that really works and attracts
                users, then we can develop a winning music application for you.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto ">
            <StaticImage
              src="../../../images/solution/music/streamingapp.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={745}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Streamingapp;
